
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"30.055","height":"19.173","x":".414","y":".414","fill":"#FFF","stroke":"#979797","stroke-width":".827","rx":"1.654"}}),_c('g',{attrs:{"fill":"#16216A"}},[_c('path',{attrs:{"d":"M20.758 6.293a5.05 5.05 0 00-1.762-.306c-1.94 0-3.31.984-3.32 2.394-.012 1.042.975 1.624 1.72 1.971.765.356 1.024.582 1.02.9-.006.486-.612.707-1.177.707-.785 0-1.202-.11-1.848-.38l-.253-.114-.276 1.623c.457.202 1.307.377 2.188.386 2.066 0 3.407-.972 3.422-2.478.007-.824-.515-1.452-1.65-1.97-.687-.336-1.107-.56-1.104-.9 0-.3.358-.623 1.126-.623a3.613 3.613 0 011.47.277l.177.084.267-1.57m5.038-.173h-1.518c-.47 0-.822.13-1.028.601l-2.92 6.647h2.065s.336-.894.413-1.09l2.516.004c.059.253.24 1.086.24 1.086h1.823l-1.591-7.248zm-2.423 4.676l.783-2.03c-.01.02.161-.419.26-.692l.133.626.456 2.096h-1.632zM10.018 6.119l-1.922 4.946-.206-1.005c-.358-1.158-1.474-2.414-2.721-3.044l1.757 6.344 2.08-.002L12.1 6.119h-2.082"}}),_c('path',{attrs:{"d":"M6.31 6.116H3.14l-.024.15c2.465.6 4.097 2.051 4.773 3.794l-.688-3.334c-.12-.46-.464-.595-.891-.612m5.357 7.252l1.228-7.252h1.966l-1.231 7.252h-1.963"}})])])])
          )
        }
      }
    